import { M_InputTextField, M_TextArea } from "../../../../M_Components";
import "../item.css"
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { TextFieldSizeEnum } from "../../../../enums/textFieldSizeEnum";

const TEXT_SIZE = {
    Code: "Code",
    Small: "Small",
    Medium: "Medium",
    Large: "Large",
    ExtraLarge: "ExtraLarge",
    ExtraExtraLarge: "ExtraExtraLarge"
}

const TEXT_FIELD_INPUT = [
    TEXT_SIZE.Small,
    TEXT_SIZE.Medium
];


export const TextFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    useEffect(() => {
        if (itemForm.form[field.Code] === null || itemForm.form[field.Code] === undefined) {
            return;
        }

        const maxLenght = TextFieldSizeEnum[field.TextSize];
        if (itemForm.form[field.Code].length > maxLenght) {
            changeValueCallback({
                ...itemForm,
                errors: {
                    ...itemForm.errors,
                    [field.Code]: t('NgeInvalidLength')
                }
            });
            return;
        }

        changeValueCallback({
            ...itemForm,
            errors: {
                ...itemForm.errors,
                [field.Code]: null
            }
        });


    }, [itemForm.form[field.Code]]);
    const handleInputChange = (value) => {
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: value
            }
        });
    }


    const cssClass = () => {
        switch (field.TextSize) {
            case TEXT_SIZE.Code:
                return "text-small";
            case TEXT_SIZE.Small:
                return "text-small";
            case TEXT_SIZE.Medium:
                return "text-medium";
            default:
                return "text-large";
        }
    };

    return (
        <div className={cssClass()}>
            {
                !TEXT_FIELD_INPUT.includes(field.TextSize) &&
                <M_TextArea
                    label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                    value={itemForm.form[field.Code] || ''}
                    required={field.IsMandatory}
                    disabled={isDisabled}
                    color={itemForm.errors[field.Code] === null || itemForm.errors[field.Code] === undefined ? null : 'var(--color-red)'}
                    helperText={itemForm.errors[field.Code]}
                    onChange={(e) => handleInputChange(e.target.value)}
                />
            }
            {
                TEXT_FIELD_INPUT.includes(field.TextSize) &&
                <M_InputTextField
                    label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                    value={itemForm.form[field.Code] || ''}
                    required={field.IsMandatory}
                    disabled={isDisabled}
                    color={itemForm.errors[field.Code] === null || itemForm.errors[field.Code] === undefined ? null : 'var(--color-red)'}
                    helperTextMessage={itemForm.errors[field.Code]}
                    onChange={(e) => handleInputChange(e.target.value)}
                />
            }
        </div>
    );
}